import { DBACTIONVARTYPES, TpDashboardActionContext } from '../interfaces';

export function resolveActionVariablesInString(ctx: TpDashboardActionContext, inputString: string): string {
  if (!inputString) return inputString;
  let outputString = inputString;
  for (const [variableName, variableContent] of Object.entries(ctx.variables)) {
    if (variableContent.type !== DBACTIONVARTYPES.Value) {
      continue;
    }
    outputString = outputString.replace('$' + variableName, variableContent.content);
  }
  return outputString;
}

export function jsonReplaceDbActionVariables(ctx: TpDashboardActionContext, jsonInput: any): any {
  // Takes a JSON object, and returns a copy where string values of the structure "$VariableName"
  // are replaced by the corresponding value of that variable in the action context

  function replaceParameters(val: string): any {
    for (const [variableName, variableContent] of Object.entries(ctx.variables)) {
      if (variableContent.type == DBACTIONVARTYPES.Value) if (val == '$' + variableName) return variableContent.content;
    }
    return val;
  }

  function recursiveReplace(jsonSub: any) {
    if (Array.isArray(jsonSub)) {
      for (const [idx, el] of jsonSub.entries()) {
        if (typeof el == 'string') {
          jsonSub[idx] = replaceParameters(el);
        } else {
          recursiveReplace(el);
        }
      }
      return;
    }
    if (typeof jsonSub == 'object') {
      for (const [key, val] of Object.entries(jsonSub)) {
        if (typeof val == 'string') {
          jsonSub[key] = replaceParameters(val);
        } else {
          recursiveReplace(val);
        }
      }
    }
  }

  const json = structuredClone(jsonInput);
  recursiveReplace(json);
  return json;
}
